import * as types from './mutation-types'

export const mutations = {
    [types.SIGN_IN](state, user_payload) {
        state.user = user_payload
        sessionStorage.setItem("user", JSON.stringify(user_payload))
    },
    [types.SIGN_OUT](state) {
        state.user = {}
        state.loggedIn = false;
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("admin");
        sessionStorage.removeItem("member");
    },
    [types.LOGGED_IN](state) {
        state.loggedIn = true
    },
    [types.LOGGED_OUT](state) {
        state.loggedIn = false
    },
    [types.SET_ADMIN](state, admin_payload) {
        state.admin = admin_payload
        sessionStorage.setItem("admin", JSON.stringify(admin_payload))
    },
    [types.SET_MEMBER](state, member_payload) {
        state.member = member_payload
        sessionStorage.setItem("member", JSON.stringify(member_payload))
    },
    [types.SET_ADMINS](state, admins_payload) {
        state.admins = admins_payload
    }
}